import styled, { css } from 'styled-components';
import { Button, Popover } from 'antd';
import { Modal } from 'reactstrap';
import InfoIcon from '../../../components/InfoIcon';
import { fadeIn } from '../../../shared';
import { Grid } from '@mantine/core';

const fillWeekBlue = '#0066b3';

const StyledModal = styled(Modal)`
  .modal-content {
    border-radius: 0;

    .modal-body {
      padding: 1.5rem 1rem;

      @media only screen and (max-width: 550px) {
        font-size: 0.95rem;
      }
    }

    .modal-header {
      > h5 {
        font-weight: 600;
      }

      .close {
        outline: 0;
        margin: -0.75rem -1rem -1rem auto;
      }
    }

    .modal-footer {
      button {
        width: 7rem;
      }
    }
  }
`;

const StyledInlineErrorMessage = styled.div`
  font-size: 85%;
  color: #a80116;
  opacity: 0.75;
  filter: brightness(1.5);
  animation: ${fadeIn} 0.3s both ease-in-out;
`;

const ButtonContainer = styled(Grid)`
  display: flex;
  width: 100%;
  border-top: 1px solid #efefef;
  border-bottom: 1px solid #efefef;
  padding-top: 1rem;
  padding-bottom: 1rem;
  margin-top: 1rem;
`;

const StyledAddActionButton = styled(Button)`
  background-color: #efefef;
  margin-right: 1rem;

  @media only screen and (max-width: 769px) {
    position: relative !important;
    bottom: inherit !important;
    width: 100%;
  }

  svg {
    font-size: 1.05rem;
    margin-right: 0.65rem;
    vertical-align: -0.15em;
  }
`;

const StyledDatePickerLabel = styled.div`
  font-size: 90%;
  font-weight: bold;
`;

const StyledTimeEntryHeader = styled(Grid)`
  align-items: center;
  font-size: 85%;

  div {
    margin-bottom: -15px;
  }
`;

const StyledTimeEntryRow = styled(Grid)`
  align-items: center;
  font-size: 85%;
  padding-top: 0.75em;
  border-top: 1px solid #e6e6e6;
`;

const StyledTimeEntryCol = styled(Grid.Col)`
  ${(props) =>
    props.centered
      ? css`
          text-align: center;
        `
      : ''}
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const StyledInfoIcon = styled(InfoIcon)`
  position: absolute;
  cursor: pointer;
  right: -6px;
  bottom: -6px;
  z-index: 1;
`;

const StyledAddActionButtonWrapper = styled.div`
  position: relative;
  background-color: #efefef;
  margin: 0 0.5em;
`;

export {
  StyledModal,
  StyledTimeEntryHeader,
  StyledTimeEntryRow,
  StyledTimeEntryCol,
  StyledInlineErrorMessage,
  StyledAddActionButton,
  ButtonContainer,
  StyledDatePickerLabel,
  StyledInfoIcon,
  StyledAddActionButtonWrapper,
};
